<mat-icon [matMenuTriggerFor]="menu">{{icon}}</mat-icon>
<mat-menu #menu="matMenu" class="menu-fit-content">
  <div mat-menu-item [disableRipple]="true" (click)="$event.stopPropagation()">
    <ng-content></ng-content>
  </div>
</mat-menu>
